declare global {
  interface Window {
    env: any;
  }
}

export function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

export function supportsWebCrypto() {
  return window.crypto && window.crypto.subtle;
}
